<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">预警服务</span></div>
            
            <!-- <el-divider content-position="left">预警类型</el-divider> -->
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.name" :name="item.name" v-for="(item,groupIndex) in alertList" :key="groupIndex">
                    <el-table 
                        :data="item.items" 
                        border :header-cell-style="{background:'#eef1f6',color:'#606266'}" height="800"
                                style="width: 80%;margin-top: 10px;" ref="Table" >
                        <el-table-column prop="订单编号" align="center" sortable width="130" label="订单编号">
                        </el-table-column>
                        <el-table-column prop="终端客户" align="center" sortable  label="终端客户" ></el-table-column>
                        <el-table-column prop="产品名称" align="center" sortable label="产品名称" ></el-table-column>
                        <el-table-column prop="数量" align="center" sortable width="60" label="数量" ></el-table-column>
                        <el-table-column prop="跟进日期" align="center" width="200" label="跟进日期" >
                            <template slot-scope="scope" >
                                {{scope.row.planSDate.split('T')[0]}} 至  {{scope.row.planEDate.split('T')[0]}}
                            </template>
                        </el-table-column> 
                        <el-table-column prop="topic" align="center" sortable width="170" label="任务主题" ></el-table-column>
                        <el-table-column prop="leftDay" align="center" sortable width="80" label="状态" >
                            <template slot-scope="scope" >
                                <span :style="scope.row.leftDay=='已过期'?'color:grey;':'color:red;'">{{scope.row.leftDay}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="执行状态" align="center" sortable width="110" label="执行状态" >
                            <template slot-scope="scope" >
                                <span :style="scope.row.执行状态=='超期未执行'?'color:red;':
                                    scope.row.执行状态=='执行期(未执行)'?'color:yellow':
                                    scope.row.执行状态=='待执行'?'':'color:gray'">
                                    {{scope.row.执行状态=='超期未执行' || scope.row.执行状态=='超期执行'?'***'+scope.row.执行状态:scope.row.执行状态}}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="rowTime" align="center" sortable width="160" label="创建时间" ></el-table-column>
                        <el-table-column align="center" width="140" label="编辑" >
                            <template slot-scope="scope" >
                                <el-button type="text" @click="onDoClick(scope.row)">跟进</el-button>
                            </template>
                        </el-table-column>                                    
                    </el-table>
                </el-tab-pane>
               
            </el-tabs>


            <!-- 3. 预警-分类
1）未按时沟通
2）续约日预警
3）培训日期 -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'baseform',
    components: {

      },
    computed: {
        ...mapGetters(['alertList'])
    },
    data() {
        return {
            activeName:'',
            // alertTypeList:[{name:'沟通预警',img:require('@/assets/hxkh.png')},{name:'续约预警',img:require('@/assets/zykh.png')},{name:'培训预警',img:require('@/assets/ybkh.png')}],
        };
    },

    async mounted() {
        console.log('1111')
        // await this.$store.dispatch('zc/alertList');
        await this.$store.dispatch('zc/alertList',{}).then(()=>{
            this.activeName=this.alertList[0].name;                
        })	
    },


    methods: {
        
    }
};
</script>

<style scoped>
    .group-item{
        display:flex;  
        margin-top:5px;      
    }
    .box-card{
        display:flex;
        align-items: center;
        width:100%;
        
    }
</style>